import { ukFormat } from "@/lib/ukFormat"

const DISPLAY_FORMAT = "dd MMM yyyy, HH:mm"

/**
 * The error to show before saving a timesheet whose clock-out isn't after its clock-in,
 * in UK time, or null if the times are fine (or either is missing or unreadable). The server rejects the
 * same case, but quotes UTC timestamps.
 */
export function timesheetTimesError(clockedIn?: string | null, clockedOut?: string | null) {
  if (!clockedIn || !clockedOut) return null
  const inMs = new Date(clockedIn).getTime()
  const outMs = new Date(clockedOut).getTime()
  // An unreadable time can't be compared or shown; leave it to the server to reject.
  if (Number.isNaN(inMs) || Number.isNaN(outMs) || inMs < outMs) return null

  return `Clock-out (${ukFormat(clockedOut, DISPLAY_FORMAT)}) must be after clock-in (${ukFormat(clockedIn, DISPLAY_FORMAT)}).`
}
